import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import './style-modal.scss';

function WarningIssue(props) {
    const [title, setTitle] = useState('')
    const [message, setMessage] = useState('')

    const onShow = async () => {
        setTitle(props.item?.title || 'Warning')
        setMessage(props.item?.message || 'Please check')
    }

    return (
        <>
            <Modal show={props.show} onHide={props.onHide} aria-labelledby="Warning"
                backdrop="static"
                keyboard={false}
                centered={true}
                size={props.size || "md"}
                className="modal-alert"
                onShow={onShow}
            >
                <Modal.Header>{/*closeButton*/}
                    <Modal.Title className="title text-center">
                        <div>
                            <i className="fa fa-exclamation-circle icon-warning" aria-hidden="true"></i>
                        </div>
                        <div>
                            {title}
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center message">
                        {message}
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ margin: 'auto', border: 'none' }}>
                    <div>
                        <div className="text-center">
                            <Button style={{minWidth: '330px'}} size="lg" variant="primary" onClick={props.onNext}> OK </Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default WarningIssue;